module.exports = __webpack_public_path__ + "static/IMG_5775.11a1edb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/examples/IMG_5775.jpg
// module id = 576
// module chunks = 35783957827783